import { createContext, useContext } from 'react';
import { ModuleKey, Role } from '../access/modules';

export interface TenantAccessContextType {
    can: (module: ModuleKey) => boolean;
    role: Role | undefined;
    isOwner: boolean;
    isManager: boolean;
    isCashier: boolean;
    user: any;
    isLoading: boolean;
}

export const TenantAccessContext = createContext<TenantAccessContextType | undefined>(undefined);

export const useTenantAccess = () => {
    const context = useContext(TenantAccessContext);
    if (!context) {
        throw new Error('useTenantAccess must be used within a TenantAccessProvider');
    }
    return context;
};
